import { useMutation, useQuery } from '@apollo/client';
import { generatePath } from 'react-router';

import {
  accountFormToGraphql,
  accountGraphqlToForm,
} from '../../../app/data/accountConversions';
import {
  ACCOUNT_QUERY,
  UPDATE_ACCOUNT_MUTATION,
} from '../../../app/graphql/accountQueries';
import routes from '../../../app/routes';
import AdminConsoleDetail from '../common/AdminConsoleDetail';
import AdminAccountPickListCard from './detail/AdminAccountPickListCard';

export default function AdminAccountPickList({ accountNumber, section }) {
  const [mutate] = useMutation(UPDATE_ACCOUNT_MUTATION);
  const { data, loading } = useQuery(section.query);

  const save = async (_account, values) => {
    await mutate({ variables: { accountNumber, input: values } });
  };

  const sectionHomeRoute = generatePath(
    routes.admin.accountDetail[section.routeKey],
    { accountNumber }
  );

  return (
    <AdminConsoleDetail
      query={ACCOUNT_QUERY}
      variables={{ accountNumber }}
      graphqlToForm={accountGraphqlToForm}
      formToGraphql={accountFormToGraphql}
      save={save}
      saveSuccessMessageId="admin.userManagement.accountDetail.save.success"
      getAfterSaveRedirectRoute={() => sectionHomeRoute}
      sectionHomeRoute={sectionHomeRoute}
      steps={[
        {
          path: routes.admin.accountDetail.root,
          routeProps: { exact: false },
          component: AdminAccountPickListCard,
          props: {
            sectionHomeRoute,
            formToGraphql: accountFormToGraphql,
            section,
            data: data?.[section.dataKey],
            loading,
          },
        },
      ]}
      getStepsProps={account => ({ account })}
    />
  );
}
